/* 
 * 图片静态资源表，所有图片资源路径在这统一管理，不应该写死在页面中，该数据挂载到Vue原型中。
 * 页面使用：this.$mAssetsPath.grid_1
 * CSS背景：应尽量使用:style="" 行内样式设置背景图
 * PATH说明：本地路径或者服务器路径
 * 
 * 举例：<image :src="grid_1">  需要在data中映射 grid_1: this.$mAssetsPath.grid_1
 * 
 * 特别注意：经测试小程序中不支持 <image :src="$mAssetsPath.grid_1"> 该用法
 */
import stylefalse from "../assets/static/img/stylefalse.png";
import styletrue from "../assets/static/img/styletrue.png";
import checkboxSelected from "../assets/static/img/checkbox-1.png";
import checkboxUnSelected from "../assets/static/img/checkbox-5.png";
import checkboxDisabled from "../assets/static/img/disabled.png";
import checkboxSelectedDisable from "../assets/static/img/checkboxSelectedDisable.png";
import information from "../assets/static/img/information.png";
import cityImg from "../assets/static/img/city.png";
import noData from "../assets/static/img/nonedata.png";
import bg from "../assets/static/img/bg.png";


import exam from "../assets/static/img/exam.png";
import defaultAvatar from "../assets/static/img/User.png";
import centerPersonalPhoto from "../assets/static/wkiwi-user/pic.png";
import centerPersonInfor from "../assets/static/wkiwi-user/opinion.png";
import centerPersonalExperience from "../assets/static/wkiwi-user/experience.png";
import centerBankAccount from "../assets/static/wkiwi-user/bank.png";
import centerCheckMoney from "../assets/static/wkiwi-user/price.png";
import centerLoginOut from "../assets/static/wkiwi-user/logout.png";
import centerTo from "../assets/static/wkiwi-user/to.png";
import chooseCity from "../assets/static/wkiwi-user/set.png";
import feedback from "../assets/static/wkiwi-user/feedback.png";
import help from "../assets/static/wkiwi-user/help.png";
import kefu from "../assets/static/wkiwi-user/kefu.png";
import videodetail from "../assets/static/wkiwi-user/videodetail.png";

import contact from "../assets/static/img/contact.png";
import sexM from "../assets/static/img/sexm.png";
import sexF from "../assets/static/img/sexf.png";
import logo from "../assets/static/img/jrhb.png";

import ic_nav_home_normal from '../assets/static/img/ic_nav_home_normal.png';
import ic_nav_home_actived from '../assets/static/img/ic_nav_home_actived.png';
import ic_nav_groupon_normal from '../assets/static/img/sq1.png';
import ic_nav_groupon_actived from '../assets/static/img/sq2.png';
import ic_nav_kingdom_normal from '../assets/static/img/ic_nav_kingdom_normal.png';
import ic_nav_kingdom_actived from '../assets/static/img/ic_nav_kingdom_actived.png';
import ic_nav_my_normal from '../assets/static/img/ic_nav_my_normal.png';
import ic_nav_my_actived from '../assets/static/img/ic_nav_my_actived.png';

import backTop from '../assets/static/img/webright_top.png';
import shareimg from '../assets/static/img/tzs-sharetip.png';
import yanxuebg from '../assets/static/img/yanxue.jpeg';
import noDataImg from '../assets/static/img/nonedata.png';
import jiaoNang from '../assets/static/img/胶囊.png'
import jiaoNangNo from '../assets/static/img/胶囊-02.png'

export default {

  jiaoNang, //吃药
  jiaoNangNo,
  exam,
  noDataImg,
  yanxuebg,
  shareimg,
  stylefalse,
  styletrue,
  ic_nav_home_normal,
  ic_nav_home_actived,
  ic_nav_groupon_normal,
  ic_nav_groupon_actived,
  ic_nav_kingdom_normal,
  ic_nav_kingdom_actived,
  ic_nav_my_normal,
  ic_nav_my_actived,
  // 首页-营期详情的报名按钮图标
  checkboxSelectedDisable, //选中且禁用
  checkboxSelected, //选中
  checkboxUnSelected, //未选中
  checkboxDisabled, //不可选
  information, //提示微信打开
  cityImg, // 浮动切换城市
  noData, // 暂无数据
  bg,
  // 个人中心menu
  defaultAvatar, //默认头像
  centerPersonalPhoto, //我的近照
  centerPersonInfor, //个人信息
  centerPersonalExperience, //个人经历
  centerBankAccount, //银行账户
  centerCheckMoney, //薪资查询
  centerLoginOut, //注销
  centerTo, //跳转箭头
  chooseCity, //切换站点
  feedback, //反馈建议
  help, //帮助中心
  kefu, //帮助中心
  videodetail, //视频资料

  // 任务
  contact, //小队长里面的图标

  sexM, //男性
  sexF, //女性
  logo, //logo
  backTop,


}